export default __webpack_public_path__ + "static/media/compound-full-logo.17756cbe.svg";